import { PerformanceDatapoint } from 'owa-analytics';
import { LazyImport, LazyModule } from 'owa-bundling';
import { SEARCH_DIAGNOSTICS_PANEL_KEY } from './logger/diagnosticsLogger';
import * as performanceTiming from './helpers/performanceTiming';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SearchDiagnostics", webpackPrefetch: true */ './lazyIndex')
);

export { PerformanceDatapoint, SEARCH_DIAGNOSTICS_PANEL_KEY };
export { default as searchDiagnosticsStore } from './store/store';

export let lazyAddSearchRequestInstrumentation = new LazyImport(
    lazyModule,
    m => m.addSearchRequestInstrumentation
);

export let lazyAddResourceTimingEntry = new LazyImport(lazyModule, m => m.addResourceTimingEntry);
export { performanceTiming };
